import { supabase } from '@/config/supabase'
import type { Lead, ValuationFormData, ValuationResult } from '@/types'
// Salva lead catturato dalla chat AI
export async function saveChatLead(data: {
  name: string
  email: string
  phone: string
  zone: string
  stima: string
  sessionId: string
}): Promise<string | null> {
  if (!data.email) return null

  const nameParts = data.name.trim().split(/\s+/)
  const firstName = nameParts[0] || ''
  const lastName = nameParts.slice(1).join(' ') || ''

  const { data: result, error } = await supabase
    .from('leads_sanremo')
    .insert({
      email: data.email,
      phone: data.phone || null,
      first_name: firstName,
      last_name: lastName,
      source: 'ai_chat',
      notes: `Chat AI — Zona: ${data.zone || 'N/A'}, Stima: ${data.stima || 'N/A'}, Session: ${data.sessionId}`,
      status: 'new',
    })
    .select('id')
    .single()

  if (error) {
    console.error('Error saving chat lead:', error)
    throw error
  }

  return result.id
}

// Salva lead su Supabase
export async function saveLead(
  formData: ValuationFormData,
  valuationId?: string
): Promise<string> {
  const lead: Partial<Lead> = {
    valuation_id: valuationId,
    email: formData.email,
    phone: formData.phone,
    first_name: formData.firstName,
    last_name: formData.lastName,
    gdpr_consent: formData.gdprConsent,
    marketing_consent: formData.marketingConsent,
    status: 'new',
  }

  const { data, error } = await supabase
    .from('leads_sanremo')
    .insert(lead)
    .select('id')
    .single()

  if (error) {
    console.error('Error saving lead:', error)
    throw error
  }

  return data.id
}

// Invia notifica email per nuovo lead via Resend (serverless function)
export async function sendLeadNotification(
  formData: ValuationFormData,
  valuation: ValuationResult
): Promise<void> {
  try {
    const fullName = [formData.firstName, formData.lastName].filter(Boolean).join(' ') || 'Non specificato'
    const formattedValue = new Intl.NumberFormat('it-IT', {
      style: 'currency',
      currency: 'EUR',
      maximumFractionDigits: 0
    }).format(valuation.estimatedValue)

    const response = await fetch('/api/send-email', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        name: fullName,
        email: formData.email,
        phone: formData.phone || 'Non specificato',
        address: formData.address,
        area: formData.area,
        value: formattedValue,
        zone: valuation.zoneName || 'N/A',
        date: new Date().toLocaleDateString('it-IT'),
        leadId: valuation.id || null,
      }),
    })

    if (!response.ok) {
      const data = await response.json().catch(() => ({}))
      if (data.reason === 'daily_limit' || data.reason === 'monthly_limit') {
        console.warn('Email quota exceeded:', data.message)
      } else if (data.reason === 'disabled') {
        console.log('Email notifications disabled server-side')
      } else {
        console.warn('Email send failed:', data)
      }
      return
    }

    console.log('Email notification sent successfully')
  } catch (error) {
    console.warn('Failed to send email notification:', error)
    // Non blocchiamo il flusso se l'email fallisce
  }
}
